import LegalLayout, { Section } from "@/components/jobbkarta/LegalLayout";
import { CONTACT_EMAIL } from "@/components/jobbkarta/Footer";

const UPDATED = "12 oktober 2026";

export default function PurchaseTerms() {
  return (
    <LegalLayout title="Köpvillkor" updated={UPDATED} testid="page-purchase-terms">
      <p>
        Dessa köpvillkor gäller när du köper den digitala produkten
        “Uppföljningsguide” från Spontan.
      </p>

      <Section heading="Produkt och pris">
        <p>
          Produkten är en digital PDF-guide som levereras direkt efter betalning.
          Priset är <strong>89 kr inkl. moms</strong>. Inga löpande avgifter
          tillkommer – det är ett engångsköp.
        </p>
      </Section>

      <Section heading="Betalning">
        <p>
          Betalning sker säkert via Stripe. Vi hanterar och lagrar aldrig dina
          kortuppgifter. När betalningen är genomförd kan du ladda ner guiden direkt.
          En orderbekräftelse (kvitto) skickas till den e-postadress du anger i kassan.
        </p>
      </Section>

      <Section heading="Leverans">
        <p>
          Guiden levereras digitalt omedelbart efter genomförd betalning som
          nedladdning i appen.
        </p>
      </Section>

      <Section heading="Ingen ångerrätt – digitala köp kan inte returneras">
        <p className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-amber-900">
          <strong>Viktigt:</strong> Eftersom produkten är en digital vara som
          levereras direkt, godkänner du vid köpet att leveransen påbörjas
          omedelbart och att du därmed <strong>frånsäger dig ångerrätten</strong>.
          Digitala köp kan därför <strong>inte returneras eller återbetalas</strong>{" "}
          när nedladdningen eller leveransen har påbörjats.
        </p>
      </Section>

      <Section heading="Fel på produkten">
        <p>
          Skulle du inte kunna ladda ner eller öppna guiden på grund av ett
          tekniskt fel hos oss, kontakta oss så hjälper vi dig att få tillgång till
          den du har betalat för. Mejla{" "}
          <a className="font-medium text-emerald-700 hover:underline" href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>{" "}
          med ditt orderkvitto.
        </p>
      </Section>
    </LegalLayout>
  );
}
